exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rdrDefinedRangesWrapper{width:145px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/dynamic-list/components/elements/dateRangeOverrides.css
// module id = 472
// module chunks = 0